// Reusable Tapas Selector Widget
// Visual drag-and-drop tapas selection component

window.TapasSelector = (function() {
  'use strict';

  // Tapas data with colors and shapes
  function getTapasItemData(name) {
    const nameLower = name.toLowerCase();
    let color = "#DDD";
    let shape = "🔵";

    if (nameLower.includes("hummus")) {
      color = "#D4B896";
      shape = "🟤";
    } else if (nameLower.includes("baba")) {
      color = "#9B6B9E";
      shape = "🟣";
    } else if (nameLower.includes("dolma")) {
      color = "#7CB342";
      shape = "🟢";
    } else if (nameLower.includes("labne")) {
      color = "#F5F5DC";
      shape = "⚪";
    } else if (nameLower.includes("tzatziki")) {
      color = "#F5F5F5";
      shape = "⚪◌";
    } else if (nameLower.includes("walnut") || nameLower.includes("pepper")) {
      color = "#C85A54";
      shape = "🟤";
    } else if (nameLower.includes("olive") || nameLower.includes("tapenade")) {
      color = "#424242";
      shape = "⚫";
    } else if (nameLower.includes("beet") || nameLower.includes("skordalia")) {
      color = "#E57373";
      shape = "🔴";
    } else if (nameLower.includes("squash") || nameLower.includes("butternut")) {
      color = "#FFB74D";
      shape = "🟠";
    }

    return { name: name, color: color, shape: shape };
  }

  // Build tapas selector HTML
  function buildHTML(options, maxSelections, containerId) {
    const tapasOptions = options || [];
    const halfPoint = Math.ceil(tapasOptions.length / 2);
    const leftOptions = tapasOptions.slice(0, halfPoint);
    const rightOptions = tapasOptions.slice(halfPoint);

    let html = `
      <div class="tapas-inline-selector" data-max-selections="${maxSelections}" data-container-id="${containerId}">
        <h4 class="tapas-inline-selector__header">Choose Any ${maxSelections} Tapas</h4>
        <div class="tapas-inline-selector__layout">
          <div class="tapas-inline-selector__column tapas-inline-selector__column--left">`;

    leftOptions.forEach(function(option) {
      const tapasData = getTapasItemData(option);
      html += `
            <div class="tapas-inline-item" draggable="true" data-tapas="${option}" data-color="${tapasData.color}" data-shape="${tapasData.shape}">
              <div class="tapas-inline-icon" style="background-color: ${tapasData.color};">
                <span class="tapas-inline-shape">${tapasData.shape}</span>
              </div>
              <span class="tapas-inline-name">${option}</span>
            </div>`;
    });

    html += `
          </div>
          <div class="tapas-inline-selector__column tapas-inline-selector__column--center">
            <div class="tapas-inline-platter">
              <div class="tapas-inline-platter-slots"></div>
            </div>
            <p class="tapas-inline-status" aria-live="polite">Select ${maxSelections} tapas</p>
            <a href="#" class="tapas-inline-clear" style="display:none;">remove all</a>
          </div>
          <div class="tapas-inline-selector__column tapas-inline-selector__column--right">`;

    rightOptions.forEach(function(option) {
      const tapasData = getTapasItemData(option);
      html += `
            <div class="tapas-inline-item" draggable="true" data-tapas="${option}" data-color="${tapasData.color}" data-shape="${tapasData.shape}">
              <div class="tapas-inline-icon" style="background-color: ${tapasData.color};">
                <span class="tapas-inline-shape">${tapasData.shape}</span>
              </div>
              <span class="tapas-inline-name">${option}</span>
            </div>`;
    });

    html += `
          </div>
        </div>
        <input type="hidden" class="tapas-selections-input" name="properties[Tapas Selections]" value="">
      </div>`;

    return html;
  }

  // Initialize tapas selector functionality
  function initialize(containerElement) {
    if (!containerElement) return;

    const selector = containerElement.querySelector('.tapas-inline-selector');
    if (!selector) return;

    const maxSelections = parseInt(selector.dataset.maxSelections) || 6;
    const platterSlots = selector.querySelector('.tapas-inline-platter-slots');
    const statusText = selector.querySelector('.tapas-inline-status');
    const clearLink = selector.querySelector('.tapas-inline-clear');
    const hiddenInput = selector.querySelector('.tapas-selections-input');
    const tapasItems = selector.querySelectorAll('.tapas-inline-item');

    // Track tapas with quantities: { name: { count, color, shape, position } }
    let tapasGroups = {};

    // Get total count across all tapas
    function getTotalCount() {
      return Object.values(tapasGroups).reduce((sum, group) => sum + group.count, 0);
    }

    // Get selections as array (with duplicates)
    function getSelections() {
      const selections = [];
      Object.entries(tapasGroups).forEach(([name, group]) => {
        for (let i = 0; i < group.count; i++) {
          selections.push(name);
        }
      });
      return selections;
    }

    // Update status and hidden input
    function updateStatus() {
      const totalCount = getTotalCount();
      const remaining = maxSelections - totalCount;

      if (remaining === maxSelections) {
        statusText.textContent = `Select ${maxSelections} tapas`;
        clearLink.style.display = 'none';
      } else if (remaining === 0) {
        statusText.textContent = 'All slots filled!';
        clearLink.style.display = 'inline';
      } else {
        statusText.textContent = `Select ${remaining} more`;
        clearLink.style.display = 'inline';
      }

      // Update hidden input with comma-separated values (with duplicates)
      if (hiddenInput) {
        hiddenInput.value = getSelections().join(', ');
      }

      // Trigger custom event for external listeners
      const event = new CustomEvent('tapasSelectionChanged', {
        detail: {
          selections: getSelections(),
          count: totalCount,
          max: maxSelections,
          isFull: totalCount === maxSelections
        }
      });
      containerElement.dispatchEvent(event);
    }

    // Render all tapas groups on the platter
    function renderPlatter() {
      platterSlots.innerHTML = '';

      const groupNames = Object.keys(tapasGroups);
      groupNames.forEach((name, index) => {
        const group = tapasGroups[name];

        // Position at specific platter compartment locations
        // Platter compartments are at clock positions: 6:00, 8:25, 11:25, 1:50, 4:10, and center
        // Each compartment can hold 2 items stacked
        const compartmentPositions = [
          { x: 0, y: 55 },      // 6:00 (bottom)
          { x: -51, y: 21 },    // 8:25 (lower left)
          { x: -35, y: -35 },   // 11:25 (upper left)
          { x: 35, y: -35 },    // 1:50 (upper right)
          { x: 51, y: 21 },     // 4:10 (lower right)
          { x: 0, y: 0 }        // Center
        ];

        const compartmentIndex = index % 6;
        const itemLayer = Math.floor(index / 6);
        const basePos = compartmentPositions[compartmentIndex] || { x: 0, y: 0 };

        // Offset second item slightly (overlap effect)
        const offset = itemLayer * 8;
        const pos = { x: basePos.x + offset, y: basePos.y + offset };

        // Create slot element
        const slot = document.createElement('div');
        slot.className = 'tapas-inline-platter-slot';
        slot.style.transform = `translate(${pos.x}px, ${pos.y}px)`;
        if (itemLayer > 0) {
          slot.style.zIndex = itemLayer;
        }

        const quantityBadge = group.count > 1 ? `<span class="tapas-inline-quantity-badge">${group.count}</span>` : '';

        slot.innerHTML = `
          <div class="tapas-inline-platter-item" style="background-color: ${group.color};" data-group-name="${name}">
            <span class="tapas-inline-platter-shape">${group.shape}</span>
            ${quantityBadge}
            <button type="button" class="tapas-inline-remove-btn" data-group-name="${name}" aria-label="Remove ${name}">×</button>
            <span class="tapas-inline-platter-name">${name}</span>
          </div>
        `;

        // Remove button
        slot.querySelector('.tapas-inline-remove-btn').addEventListener('click', function(e) {
          e.preventDefault();
          removeTapas(name);
        });

        platterSlots.appendChild(slot);
      });

      updateStatus();
    }

    // Add tapas to platter
    function addTapas(tapasName, color, shape) {
      const totalCount = getTotalCount();

      if (totalCount >= maxSelections) {
        showToast('Maximum selections reached!', 'warning');
        return false;
      }

      // If this tapas already exists, increment count
      if (tapasGroups[tapasName]) {
        tapasGroups[tapasName].count++;
      } else {
        // Create new group
        tapasGroups[tapasName] = {
          count: 1,
          color: color,
          shape: shape
        };
      }

      renderPlatter();
      return true;
    }

    // Remove one instance of tapas from platter
    function removeTapas(tapasName) {
      if (!tapasGroups[tapasName]) return;

      tapasGroups[tapasName].count--;

      // Remove group if count reaches 0
      if (tapasGroups[tapasName].count <= 0) {
        delete tapasGroups[tapasName];
      }

      renderPlatter();
    }

    // Clear all selections
    function clearAll() {
      tapasGroups = {};
      platterSlots.innerHTML = '';
      updateStatus();
    }

    // Item click handlers - click to add
    tapasItems.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        const tapasName = this.dataset.tapas;
        const color = this.dataset.color;
        const shape = this.dataset.shape;

        addTapas(tapasName, color, shape);
      });
    });

    // Drag and drop functionality
    let draggedItem = null;

    tapasItems.forEach(function(item) {
      item.addEventListener('dragstart', function(e) {
        draggedItem = this;
        this.style.opacity = '0.5';
        e.dataTransfer.effectAllowed = 'copy';
      });

      item.addEventListener('dragend', function() {
        this.style.opacity = '1';
        draggedItem = null;
      });
    });

    // Platter drop zone
    platterSlots.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      this.classList.add('drag-over');
    });

    platterSlots.addEventListener('dragleave', function() {
      this.classList.remove('drag-over');
    });

    platterSlots.addEventListener('drop', function(e) {
      e.preventDefault();
      this.classList.remove('drag-over');

      if (draggedItem) {
        const tapasName = draggedItem.dataset.tapas;
        const color = draggedItem.dataset.color;
        const shape = draggedItem.dataset.shape;

        addTapas(tapasName, color, shape);
      }
    });

    // Clear button
    if (clearLink) {
      clearLink.addEventListener('click', function(e) {
        e.preventDefault();
        clearAll();
      });
    }

    // Public API - expose methods on the container element
    containerElement.tapasSelector = {
      getSelections: getSelections,
      getCount: getTotalCount,
      getMax: () => maxSelections,
      isFull: () => getTotalCount() === maxSelections,
      clear: clearAll,
      addTapas: addTapas,
      removeTapas: removeTapas
    };

    updateStatus();
  }

  // Simple toast notification (fallback until full toast system is implemented)
  function showToast(message, type) {
    if (window.showToast) {
      window.showToast(message, type);
    } else {
      console.warn(message);
    }
  }

  // Public API
  return {
    buildHTML: buildHTML,
    initialize: initialize,
    getTapasItemData: getTapasItemData
  };
})();
